import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import FormBanner from '../../FormBanner';
import Form from '../../Forms/Form';

const styles = css`
`;

function ContactFormShort({ content }) {
  return (
    <div className={styles}>
      <FormBanner
        content={get(content, '[0]')}
        redirectRoute={get(content, '[0].success_route')}
        formArea={
          <Form
            formName="contactUs"
            formLabel="Contact Us"
            fields={[
              {
                type: 'Text',
                label: 'Full Name',
                className: 'form-col',
                field: 'name',
                required: true,
              },
              {
                type: 'Email',
                label: 'Email',
                className: 'form-col',
                field: 'email',
                required: true,
                requiredMessage: '',
                invalidMessage: '',
              },
              {
                type: 'TextArea',
                label: 'Comments/Questions',
                className: 'form-col-fluid',
                placeholder: 'How can we help you?',
                field: 'comments',
                required: true,
              },
            ]}
          />
        }
      />
    </div>
  );
}


ContactFormShort.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

ContactFormShort.defaultProps = {
};

export default ContactFormShort;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/ContactFormShort.section.js